// chat.constants — стартові значення для сесії чату.

import i18n from "../i18n";

export function getInitialMessages() {
  return [
    {
      role: "assistant",
      animate: true,
      parts: [
        { t: i18n.t("chat:welcome_part1"), w: "bold" },
        { t: i18n.t("chat:welcome_part2"), w: "medium" },
        { t: i18n.t("chat:welcome_part3"), w: "bold" },
        { t: i18n.t("chat:welcome_part4"), w: "medium" },
      ],
    },
  ];
}

export function getInitialCTAs() {
  return [
    {
      id: "cta_sale",
      label: i18n.t("chat:cta_sale"),
      sublabel: i18n.t("chat:cta_sale_sub"),
      action: {
        type: "send",
        message: i18n.t("chat:msg_sale"),
      },
    },
    {
      id: "cta_new",
      label: i18n.t("chat:cta_new"),
      sublabel: i18n.t("chat:cta_new_sub"),
      action: {
        type: "send",
        message: i18n.t("chat:msg_new"),
      },
    },
    {
      id: "cta_top",
      label: i18n.t("chat:cta_top"),
      sublabel: i18n.t("chat:cta_top_sub"),
      action: {
        type: "send",
        message: i18n.t("chat:msg_top"),
      },
    },

    // Beer styles

    {
      id: "cta_ipa",
      label: "IPA",
      sublabel: "Хмільне пиво",
      action: {
        type: "send",
        message: "Покажи IPA",
      },
    },
    {
      id: "cta_porter",
      label: "Porter",
      sublabel: "Темне пиво",
      action: {
        type: "send",
        message: "Покажи Porter",
      },
    },
    {
      id: "cta_stout",
      label: "Stout",
      sublabel: "Насичений темний стиль",
      action: {
        type: "send",
        message: "Покажи Stout",
      },
    },
    {
      id: "cta_golden_ale",
      label: "Golden Ale",
      sublabel: "Світлий ель",
      action: {
        type: "send",
        message: "Покажи Golden Ale",
      },
    },
    {
      id: "cta_lager",
      label: "Lager",
      sublabel: "Легке класичне пиво",
      action: {
        type: "send",
        message: "Покажи Lager",
      },
    },
    {
      id: "cta_milkshake_ipa",
      label: "Milkshake IPA",
      sublabel: "Мʼяка IPA",
      action: {
        type: "send",
        message: "Покажи Milkshake IPA",
      },
    },
    {
      id: "cta_neipa",
      label: "NEIPA",
      sublabel: "Соковита IPA",
      action: {
        type: "send",
        message: "Покажи NEIPA",
      },
    },
    {
      id: "cta_other",
      label: "Other",
      sublabel: "Інші стилі",
      action: {
        type: "send",
        message: "Покажи Other",
      },
    },
    {
      id: "cta_sour",
      label: "Sour",
      sublabel: "Кисле пиво",
      action: {
        type: "send",
        message: "Покажи Sour",
      },
    },
    {
      id: "cta_tomato",
      label: "Tomato",
      sublabel: "Томатне пиво",
      action: {
        type: "send",
        message: "Покажи Tomato",
      },
    },
    {
      id: "cta_wheat",
      label: "Wheat",
      sublabel: "Пшеничне пиво",
      action: {
        type: "send",
        message: "Покажи Wheat",
      },
    },
  ];
}